import React from "react";
import { Link } from "react-router-dom";
import LWSBlog from "../../assets/images/LWSBlog.svg";

export default function BrandLogo() {
  return (
    <>
      <div className="logo">
        <Link to="/">
          <img src={LWSBlog} alt="search" />
        </Link>
      </div>
    </>
  );
}
